const isSameLowerCaseString = (value1, value2) => {
  if (typeof value1 !== 'string' || typeof value2 !== 'string') return false;
  return value1.toLocaleLowerCase() === value2.toLocaleLowerCase();
};

export default isSameLowerCaseString;
